<template>
    <div>
        <header-portrate />
        <div style="margin-bottom:70px;">
        <bread-crumbs :items="items"></bread-crumbs>
        <tabs-comp :tabs="tabs" />
        <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:25px !important;`">
            <v-col
                cols="12" md="12" sm="12" class="text-end">
                <b-button variant="success"
                class="btn-sm addemployeecl"
                :style="`width:150px;margin-`+lang.lalgin+`:6px;background:transparent;border:none`" flat
                v-b-toggle.add_users
                id="multiply-button"
                color="success">
                <div style="width:150px;color:#000" :class="`multiply-button-content-`+lang.lalgin">{{lang.add_user}}</div>
                </b-button>
            </v-col>
        </v-row>
        <v-row class="mainrow m-2">
            <!-- <v-col>
                <v-btn
                    v-b-toggle.add_users
                    style="background: green !important;color:#FFF !important;float:left">
                    {{lang.add_user}}</v-btn>
            </v-col> -->
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="tablerows"
                    width="100%"
                    id="MainTable"
                >
                    <template v-slot:item="row">
                        <tr>
                            <td>{{ row.item.counter }}</td>
                            <td>{{ row.item[`branch_${lang.langname}`] }}</td>
                            <td>{{ row.item[`store_${lang.langname}`] }}</td>
                            <td>{{ row.item.full_name }}</td>
                            <td>{{ row.item.username }}</td>
                            <td>{{ row.item.employee_name }}</td>
                            <td nowrap>{{ row.item.permission }}</td>
                            <td nowrap>{{ costCenters[row.item.cost_center] }}</td>

                            <td class="text-center" style="width:60px;background:#000;border-bottom:1px solid #fff !important;">
                                <v-btn style="width:100px;font-size:0.2em;background:#000;color:#FFF;height:25px !important;margin-inline-end:5px;" @click="ViewItem(row.item)" v-b-toggle.update_users>{{lang.update}}</v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <addUser />
        <editUser ref="updateUser" />
    </div>
        <Footer />
    </div>
</template>

<script>
import axios from 'axios'
import addUser from '@/components/addUser.vue';
import editUser from '@/components/editUser.vue';
import BreadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import { getVisibleTabsForRoute } from '@/menu/menuService'
export default{
  components: { addUser, BreadCrumbs, TabsComp, HeaderPortrate, Footer, editUser },
    data() {
        return {
            active_tab:0,

            refreshTimer: null,

            tablerows: [

            ]
        }
    },
    methods: {
        ViewItem(item){
            this.$refs.updateUser.resetValue(item);
            // this.$router.push({path: '/updateuser/'+item.id})
        },
        getUsers(){
            const post = new FormData();
            post.append("type" , 'getUsers');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$COOKIEPhase));
            post.append('data[user]','all');
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then(
                (response) => {
                    const res = response.data;
                    // // console.log(res);
                    this.tablerows = res.results.data.results;
                }
            )
        }
    },
    created() {
        this.getUsers();
        this.refreshTimer = setInterval(
            () => {this.getUsers();},6000
        )
    },
    beforeDestroy() {
        if(this.refreshTimer){
            clearInterval(this.refreshTimer);
            this.refreshTimer = null;
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        costCenters: function(){
            return {
                1: this.lang.general_center,
                2: this.lang.german_section,
            }
        },
        tabs: function() {

            return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

        },
        items:function () {

            return {
                text: this.lang.users,
                disabled: true,
                to: '/settings/users-settings',
            }
        },
        headers: function(){
            return [
                {
                    text: '',
                    align: 'center',
                    filterable: false,
                    value: 'counter',
                },
                {
                    text: this.lang.branch,
                    align: 'center',
                    filterable: false,
                    value: 'branch_id',
                },
                {
                    text: this.lang.store,
                    align: 'center',
                    filterable: false,
                    value: 'storeid',
                },
                {
                    text: this.lang.user_name,
                    align: 'center',
                    filterable: false,
                    value: 'full_name',
                },
                {
                    text: this.lang.login_name,
                    align: 'center',
                    filterable: false,
                    value: 'username',
                },
                {
                    text: this.lang.employee_name,
                    align: 'center',
                    filterable: false,
                    value: 'employee_name',
                },
                {
                    text: this.lang.permission,
                    align: 'center',
                    filterable: false,
                    value: 'permission',
                },
                {
                    text: this.lang.income_center,
                    align: 'center',
                    filterable: false,
                    value: 'cost_center',
                },
                {
                    text: this.lang.action,
                    align: 'center',
                    filterable: false,
                },
            ]
        },
    },
}
</script>